module.exports = __webpack_public_path__ + "static/media/YM60_1.5934e9ce.jpg";